<template>
    <Form :rules="innerRules" inline populateType="chain" :value="list">
        <field-group
            v-for="(item, index) in list"
            :key="index"
            :model="item"
            class="fee-item"
        >
            <!-- 选择费用类型 -->
            <FormItem class="fee-field" prop="feeType">
                <Select
                    :disabled="finalEditable && !hasAuth"
                    v-model="item.feeType"
                    transfer
                    style="width: 160px"
                >
                    <Option
                        v-for="v in depositTypeList"
                        :value="v.id"
                        :key="v.id"
                    >
                        {{ v.text }}
                    </Option>
                </Select>
            </FormItem>
            <!-- 费用金额 -->
            <FormItem class="fee-field" prop="amount">
                <input-number
                    :disabled="finalEditable && !hasAuth"
                    v-model="item.amount"
                    type="date"
                    style="width: 200px"
                />
            </FormItem>
            <span
                v-if="finalEditable && hasAuth"
                class="fee-cut"
                @click="cut(index)"
            >
                -
            </span>
        </field-group>
        <div v-if="finalEditable && hasAuth" style="line-height: 30px">
            <div class="fee-add" @click="add">
                <span class="fee-add-plus">+</span>添加押金
            </div>
        </div>
    </Form>
</template>
<script>
// 优惠费用
import { Field } from 'ivux'

function createItem() {
    return {
        feeType: '',
        amount: 0,
    }
}

export default {
    name: 'OtherDeposit',

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        populateType: {
            type: String,
            default: 'through',
        },
    },

    data() {
        return {
            list: this.value,

            dict: {
                otherDeposit: this.$dict.NULL,
            },
        }
    },

    watch: {
        value(val) {
            this.setData(val)
        },

        list: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },

    computed: {
        innerRules() {
            return {
                feeType: [{ required: true, message: '押金类型必填' }],
                amount: [{ required: true, message: '押金金额必填' }],
            }
        },

        depositTypeList() {
            return this.dict.otherDeposit
                .toList()
                .filter((v) => JSON.safeParse(v.remark)?.isOtherDeposit)
        },

        hasAuth() {
            return this.$can('deposit', 'api/contract/info?type=zz')
        },
    },

    created() {
        this.$dict.get(['other_deposit']).then((group) => {
            Object.assign(this.dict, group)
            this.setData(this.value)
        })
    },

    methods: {
        setData(list) {
            var i = list.length

            this.list = [...list]
        },

        add() {
            this.list.push(createItem())
        },

        cut(i) {
            this.list.splice(i, 1)
        },
    },
}
</script>
<style lang="less" scoped>
.fee {
    &-item {
        margin-bottom: 11px;
    }

    &-cut {
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
